<template><div><h1 id="kommunikationskanale" tabindex="-1"><a class="header-anchor" href="#kommunikationskanale"><span>Kommunikationskanäle</span></a></h1>
<p>Kommunikationskanäle — Kanäle für die Kommunikation</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Definiert die Kanäle, womit die Kommunikation der Organisation oder der Kunden erfolgt.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Tabellen → Systemtabellen → Kommunikation → Kanäle</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Kanal</dt>
<dd>Kanl-Kurbezeichnung</dd>
<dt>Beschreibung</dt>
<dd>Detailbezeichnung</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionen</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


